import {
  PhoneOutlined,
  TelegramFilled,
  WhatsAppOutlined,
} from "@ant-design/icons";
import { Button, Space } from "antd";
import { useTranslation } from "react-i18next";

export const HelpContacts = () => {
  const { t } = useTranslation();

  return (
    <Space orientation="vertical" size="large" style={{ display: "flex" }}>
      <Button
        type="primary"
        size="large"
        icon={<PhoneOutlined />}
        style={{ margin: "0 auto", display: "flex" }}
        onClick={() => {
          window.location.href = "tel:+77000370234";
        }}
      >
        {t("support.call", { phone: "+7 700 037-02-34" })}
      </Button>

      <Button
        type="primary"
        size="large"
        icon={<WhatsAppOutlined />}
        style={{ margin: "0 auto", display: "flex" }}
        onClick={() => {
          window.open("https://wa.me/77000370234", "_blank");
        }}
      >
        {t("support.contact_support_wt")}
      </Button>

      <Button
        type="primary"
        size="large"
        icon={<TelegramFilled />}
        style={{ margin: "0 auto", display: "flex" }}
        onClick={() => {
          window.open("https://t.me/akjetkz_bot", "_blank");
        }}
      >
        {t("support.contact_support_tg")}
      </Button>
    </Space>
  );
};
